var React = require('react');

function S11 (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"s-12","transform":"translate(0.091)"},[React.createElement("rect",{"id":"Rectangle_48500","data-name":"Rectangle 48500","width":"28","height":"28","transform":"translate(-0.091)","fill":"none","key":0}),React.createElement("path",{"id":"Path_106573","data-name":"Path 106573","d":"M23.039,12.475a9.915,9.915,0,1,0-13.007,9.418,3.3,3.3,0,0,0,6.185,0A9.954,9.954,0,0,0,23.039,12.475Zm-9.915,9.915a1.655,1.655,0,1,1,1.655-1.655A1.651,1.651,0,0,1,13.125,22.389Zm3.245-2.316a3.315,3.315,0,0,0-6.491.013,8.273,8.273,0,1,1,6.491,0Z","transform":"translate(0.875 0.698)","key":1})]));
}

S11.defaultProps = {"width":"28","height":"28","viewBox":"0 0 28 28"};

module.exports = S11;

S11.default = S11;
